<template>
  <tr>
    <td data-label="Artikel-ID">{{ article.ArticleId }}</td>
    <td data-label="Name">{{ article.Name }}</td>
    <td data-label="Farbe">{{ article.Color }}</td>
    <td data-label="Größe">{{ article.Size }}</td>
    <td data-label="Gender">{{ article.Gender }}</td>
    <td data-label="Erhalten">{{ formatDate(article.ReceivedDate) }}</td>
    <td data-label="Verkauf">{{ formatDate(article.SaleDate) }}</td>
    <!-- <td data-label="Verkaufspreis">{{ article.SalePrice }}</td>-->
    <td data-label="Akt. Preis">{{ $formatPrice(getDiscountedPrice(article)) }}</td>
    <td data-label="Kunde">
      <template v-if="article.Customer">
        {{ article.Customer.FirstName }} {{ article.Customer.LastName }} ({{ article.Customer.id }})
      </template>
      <span v-else>-</span>
    </td>

    <!-- NEUE Status-Spalte -->
    <td data-label="Status" class="text-center">
      <font-awesome-icon :icon="statusIcon" :style="{ color: statusColor }" :title="statusLabel" />
    </td>

    <td data-label="Aktionen" class="d-flex gap-1">
      <button @click="$emit('edit', article)" class="btn btn-primary btn-sm">
        <font-awesome-icon icon="edit" /> Bearbeiten
      </button>
      <button
        v-if="!isSold(article)"
        @click="$emit('delete', article)"
        class="btn btn-danger btn-sm"
        title="Artikel löschen"
      >
        <font-awesome-icon icon="trash" />
      </button>
    </td>

  </tr>
</template>

<script>
export default {
  props: ['article'],
  computed: {
    // Wählt das Icon je nach Status
    statusIcon() {
      switch (this.article.ArticleStatus) {
        case 'sold':
          return 'check-circle';
        case 'returned':
          return 'undo';
        case 'disposed':
          return 'trash-alt';
        default:
          return 'box-open';
      }
    },
    // Farben passend zum Status
    statusColor() {
      switch (this.article.ArticleStatus) {
        case 'sold':
          return 'green';
        case 'returned':
          return 'blue';
        case 'disposed':
          return 'red';
        default:
          return 'gray';
      }
    },
    // Tooltip-Text
    statusLabel() {
      const map = {
        available: 'Lagernd',
        sold: 'Verkauft',
        returned: 'Retourniert',
        disposed: 'Entsorgt'
      };
      return map[this.article.ArticleStatus] || this.article.ArticleStatus;
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '-';
      const parsed = new Date(date);
      return parsed.toLocaleDateString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },
    getDiscountedPrice(article) {
      if (!article) return 0;
      return (
        article.PriceDiscountLevel3 ??
        article.PriceDiscountLevel2 ??
        article.PriceDiscountLevel1 ??
        article.SalePrice ??
        0
      );
    },
    // Löschen nur, wenn nicht verkauft
    isSold(article) {
      return article.ArticleStatus === 'sold';
    }
  }
};
</script>

<style scoped>
.d-flex {
  align-items: center;
  gap: 0.25rem;
}
</style>
